import { type RouteLocationNormalized, type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { routerHelper } from '@/services/router-helper';

const CampaignOverview = (): unknown => {
    return import(/* webpackPrefetch: true */ './campaign-overview-page.vue');
};

export const campaignOverviewRoute: RouteRecordRaw = {
    ...ROUTE_DATA.CAMPAIGN_OVERVIEW_PAGE,
    components: {
        main: CampaignOverview
    },
    props: {
        main(route: RouteLocationNormalized): { campaignId?: number } {
            return { campaignId: routerHelper.parseParamToInt(route.params.id as string) };
        }
    }
};
